(function() {
  function toArray(elements) {
    var result = [];
    var i;
    if (!elements) {
      return result;
    }
    for (i = 0; i < elements.length; i += 1) {
      result.push(elements[i]);
    }
    return result;
  }

  function trimText(value) {
    return (value || '').replace(/^\s+|\s+$/g, '');
  }

  function indexOfElement(elements, element) {
    var i;
    for (i = 0; i < elements.length; i += 1) {
      if (elements[i] === element) {
        return i;
      }
    }
    return -1;
  }

  function hasClass(element, className) {
    if (!element || !className) {
      return false;
    }
    return (
      (' ' + element.className + ' ').indexOf(' ' + className + ' ') !== -1
    );
  }

  function addClass(element, className) {
    if (!hasClass(element, className)) {
      element.className = trimText(
        (element.className + ' ' + className).replace(/\s+/g, ' ')
      );
    }
  }

  function removeClass(element, className) {
    element.className = trimText(
      (' ' + element.className + ' ')
        .replace(' ' + className + ' ', ' ')
        .replace(/\s+/g, ' ')
    );
  }

  function uniqueElements(elements, seen) {
    var result = [];
    var i;
    var element;

    for (i = 0; i < elements.length; i += 1) {
      element = elements[i];
      if (indexOfElement(seen, element) === -1) {
        seen.push(element);
        result.push(element);
      }
    }
    return result;
  }

  function toArrayWithoutElement(elements, excludedElement) {
    var result = [];
    var i;
    for (i = 0; i < elements.length; i += 1) {
      if (elements[i] !== excludedElement) {
        result.push(elements[i]);
      }
    }
    return result;
  }

  function closestByClass(node, className) {
    while (node) {
      if (hasClass(node, className)) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function closestByTag(node, tagName) {
    tagName = tagName.toUpperCase();
    if (node.closest) {
      return node.closest(tagName.toLowerCase());
    }
    while (node) {
      if (node.tagName && node.tagName.toUpperCase() === tagName) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  function moveToContentCore(root, position) {
    var contentCore = document.getElementById('content-core');
    var tileWrapper = closestByClass(root, 'tileWrapper');
    var nodeToMove = tileWrapper || root;
    var index = parseInt(position, 10);
    var tileWrappers;
    var reference;

    if (!contentCore) {
      return false;
    }

    if (index > 0 && tileWrapper) {
      tileWrappers = toArray(contentCore.getElementsByClassName('tileWrapper'));
      tileWrappers = uniqueElements(tileWrappers, []);
      tileWrappers = toArrayWithoutElement(tileWrappers, tileWrapper);
      reference = tileWrappers[index - 1] || null;
      contentCore.insertBefore(tileWrapper, reference);
      return true;
    }

    if (
      nodeToMove.parentNode !== contentCore ||
      contentCore.firstChild !== nodeToMove
    ) {
      contentCore.insertBefore(nodeToMove, contentCore.firstChild);
    }
    return true;
  }

  function normalizeText(value) {
    return trimText((value || '').toLowerCase().replace(/\s+/g, ' '));
  }

  function matchesText(element, query) {
    var terms;
    var text;
    var i;

    query = normalizeText(query);
    if (query.length < 3) {
      return true;
    }

    terms = query.split(' ');
    text = normalizeText(element.textContent || element.innerText || '');
    for (i = 0; i < terms.length; i += 1) {
      if (text.indexOf(terms[i]) === -1) {
        return false;
      }
    }
    return true;
  }

  function initFilter(root) {
    var baseFilterClass;
    var input;
    var form;
    var buttons;
    var buttonItems;
    var clearButton;
    var activeClass;
    var canModify;
    var isEditing;
    var moved;
    var buttonIndex;
    var counter;

    counter = root.querySelector('.filtri-per-classe-counter');
    if (
      root.getAttribute('data-filtri-per-classe-ready') === 'true' &&
      counter &&
      counter.textContent
    ) {
      return;
    }

    baseFilterClass = root.getAttribute('data-base-filter-class');
    input = root.querySelector('.filtri-per-classe-input');
    form = root.querySelector('.filtri-per-classe-search');
    buttons = root.querySelectorAll('.filtri-per-classe-button');
    clearButton = root.querySelector('.filtri-per-classe-clear');
    activeClass = '__all__';

    if (!baseFilterClass || !input) {
      return;
    }

    if (!document.getElementsByClassName(baseFilterClass).length) {
      return;
    }

    canModify = root.getAttribute('data-can-modify') === 'true';
    isEditing =
      document.body && document.body.className
        ? (' ' + document.body.className + ' ').indexOf(' template-edit ') !==
          -1
        : false;
    moved = true;
    if (!canModify || !isEditing) {
      moved = moveToContentCore(
        root,
        root.getAttribute('data-filter-position')
      );
    }
    if (!moved) {
      return;
    }

    root.setAttribute('data-filtri-per-classe-ready', 'true');

    function buttonClassNames() {
      var result = [];
      var i;
      var className;
      for (i = 0; i < buttonItems.length; i += 1) {
        className = buttonItems[i].getAttribute('data-filter-class');
        if (className && className !== '__all__') {
          result.push(className);
        }
      }
      return result;
    }

    function childElementsByClass(containers, classNames) {
      var seen = [];
      var result = [];
      var containerIndex;
      var classIndex;

      for (
        containerIndex = 0;
        containerIndex < containers.length;
        containerIndex += 1
      ) {
        for (classIndex = 0; classIndex < classNames.length; classIndex += 1) {
          result = result.concat(
            uniqueElements(
              containers[containerIndex].getElementsByClassName(
                classNames[classIndex]
              ),
              seen
            )
          );
        }
      }
      return result;
    }

    function managedElements() {
      var seen = [];
      var elements = topLevelElements(
        uniqueElements(document.getElementsByClassName(baseFilterClass), seen)
      );
      var classNames = buttonClassNames();
      if (elements.length === 1 && classNames.length) {
        return topLevelElements(childElementsByClass(elements, classNames));
      }
      return elements;
    }

    function topLevelElements(elements) {
      var result = [];
      var i;
      var j;
      var element;
      var nested;

      for (i = 0; i < elements.length; i += 1) {
        element = elements[i];
        nested = false;
        for (j = 0; j < elements.length; j += 1) {
          if (elements[j] !== element && elements[j].contains(element)) {
            nested = true;
            break;
          }
        }
        if (!nested) {
          result.push(element);
        }
      }
      return result;
    }

    function setVisible(element, visible) {
      element.style.display = visible ? '' : 'none';
    }

    function visibilityElement(element) {
      var row;
      if (
        element.tagName &&
        (element.tagName.toUpperCase() === 'TD' ||
          element.tagName.toUpperCase() === 'TH')
      ) {
        row = closestByTag(element, 'tr');
        if (row) {
          return row;
        }
      }
      return element;
    }

    function updateCounter(count) {
      var counter = root.querySelector('.filtri-per-classe-counter');
      if (!counter) {
        return;
      }
      counter.textContent =
        count + (count === 1 ? ' elemento trovato' : ' elementi trovati');
    }

    function applyFilter(className) {
      var showAll = className === '__all__';
      var elements = managedElements();
      var visibleElements = [];
      var visibilityTargets = [];
      var targetVisible = [];
      var query = input.value || '';
      var elementIndex;
      var i;

      for (
        elementIndex = 0;
        elementIndex < elements.length;
        elementIndex += 1
      ) {
        var element = elements[elementIndex];
        var target;
        var targetIndex;
        var visible;

        if (root.contains(element) || element.contains(root)) {
          continue;
        }
        visible =
          (showAll || hasClass(element, className)) &&
          matchesText(element, query);
        target = visibilityElement(element);
        targetIndex = indexOfElement(visibilityTargets, target);
        if (targetIndex === -1) {
          visibilityTargets.push(target);
          targetVisible.push(false);
          targetIndex = visibilityTargets.length - 1;
        }
        targetVisible[targetIndex] = targetVisible[targetIndex] || visible;
        if (visible) {
          visibleElements.push(element);
        }
      }
      for (i = 0; i < visibilityTargets.length; i += 1) {
        setVisible(visibilityTargets[i], targetVisible[i]);
      }
      updateCounter(visibleElements.length);
    }

    if (form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
      });
    }

    input.addEventListener('input', function() {
      applyFilter(activeClass);
    });
    input.addEventListener('keyup', function() {
      applyFilter(activeClass);
    });

    if (clearButton) {
      clearButton.addEventListener('click', function(event) {
        event.preventDefault();
        input.value = '';
        applyFilter(activeClass);
      });
    }

    buttonItems = toArray(buttons);
    for (buttonIndex = 0; buttonIndex < buttonItems.length; buttonIndex += 1) {
      (function(button) {
        button.addEventListener('click', function(event) {
          var itemIndex;
          event.preventDefault();
          activeClass = button.getAttribute('data-filter-class') || '__all__';

          for (itemIndex = 0; itemIndex < buttonItems.length; itemIndex += 1) {
            removeClass(buttonItems[itemIndex], 'active');
          }
          addClass(button, 'active');
          applyFilter(activeClass);
        });
      })(buttonItems[buttonIndex]);
    }

    applyFilter('__all__');
  }

  function initFiltriPerClasse() {
    var filters = toArray(document.getElementsByClassName('filtri-per-classe'));
    var i;
    for (i = 0; i < filters.length; i += 1) {
      initFilter(filters[i]);
    }
  }

  window.initFiltriPerClasse = initFiltriPerClasse;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFiltriPerClasse);
  } else {
    initFiltriPerClasse();
  }
  window.setTimeout(initFiltriPerClasse, 250);
  window.setTimeout(initFiltriPerClasse, 1000);
  window.setTimeout(initFiltriPerClasse, 2000);
  window.setTimeout(initFiltriPerClasse, 5000);
  window.addEventListener('load', initFiltriPerClasse, false);
  document.addEventListener('rtTilesLoaded', initFiltriPerClasse, true);
})();
